/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfBoolean } from "../models/AjaxResponseOfBoolean";
import type { AjaxResponseOfCreateOrEditVehicleDto } from "../models/AjaxResponseOfCreateOrEditVehicleDto";
import type { AjaxResponseOfGetVehicleForEditOutput } from "../models/AjaxResponseOfGetVehicleForEditOutput";
import type { CreateOrEditVehicleDto } from "../models/CreateOrEditVehicleDto";
import type { VehicleOptionalsUpdateInput } from "../models/VehicleOptionalsUpdateInput";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehiclesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfBoolean
   * @throws ApiError
   */
  public plateExists({
    plate,
  }: {
    plate: string;
  }): CancelablePromise<AjaxResponseOfBoolean> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicles/{plate}/placa",
      path: {
        plate: plate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVehicleForEditOutput
   * @throws ApiError
   */
  public getById({
    id,
    vehicleType,
  }: {
    id: string;
    vehicleType?: number;
  }): CancelablePromise<AjaxResponseOfGetVehicleForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicles/{id}",
      path: {
        id: id,
      },
      query: {
        vehicleType: vehicleType,
      },
    });
  }

  /**
   * @returns AjaxResponseOfCreateOrEditVehicleDto
   * @throws ApiError
   */
  public getCreatDtoByPlate({
    plate,
  }: {
    plate?: string;
  }): CancelablePromise<AjaxResponseOfCreateOrEditVehicleDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicles",
      query: {
        plate: plate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfCreateOrEditVehicleDto
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrEditVehicleDto;
  }): CancelablePromise<AjaxResponseOfCreateOrEditVehicleDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicles",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfCreateOrEditVehicleDto
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: CreateOrEditVehicleDto;
  }): CancelablePromise<AjaxResponseOfCreateOrEditVehicleDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/vehicles",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updatePartial({
    requestBody,
  }: {
    requestBody?: VehicleOptionalsUpdateInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/vehicles",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    id,
    vehicleType,
  }: {
    id?: string;
    vehicleType?: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicles",
      query: {
        id: id,
        vehicleType: vehicleType,
      },
    });
  }
}
